import React, { useEffect, useState } from "react";
import { Monitor, WifiOff, RefreshCw } from "lucide-react";
import { api } from "../lib/api";
import { MasaustuIndirButonu } from "../components/MasaustuIndirButonu";

export default function IndirPage() {
  const [durum, setDurum] = useState("bekle");
  useEffect(() => {
    api.get("/desktop/bilgi")
      .then((r) => setDurum(!r.data.gorebilir ? "yetkisiz" : r.data.var ? "hazir" : "yok"))
      .catch(() => setDurum("giris"));
  }, []);
  return (
    <div className="min-h-screen bg-sertex-bg text-white flex items-center justify-center p-6" data-testid="indir-page">
      <div className="max-w-xl w-full border border-sertex-cyan/30 rounded-lg p-8 bg-sertex-surface/60 space-y-6">
        <div className="flex items-center gap-3">
          <Monitor className="h-8 w-8 text-sertex-cyan" />
          <h1 className="text-3xl font-bold">SERTEX Masaüstü (Windows)</h1>
        </div>
        <p className="text-sm text-white/70">
          İnternet olmadan da çalışan Windows uygulaması. İnternet gelince "Giriş yap / Eşitle" ile görevleriniz bulut hesabınıza gönderilir.
          <span className="block mt-1 text-amber-300/90">Deneme sürümü: yalnızca görev oluşturma ve buluta tek yönlü gönderme.</span>
        </p>
        <ul className="text-sm text-white/70 space-y-1">
          <li className="flex items-center gap-2"><WifiOff className="h-4 w-4" /> Kurulum ve ilk açılış internetsiz çalışır.</li>
          <li className="flex items-center gap-2"><RefreshCw className="h-4 w-4" /> Masaüstü girişi web ve mobil oturumunuzu kapatmaz.</li>
        </ul>
        {durum === "bekle" && <div className="text-sm text-white/60" data-testid="indir-yukleniyor">Kontrol ediliyor…</div>}
        {durum === "hazir" && <MasaustuIndirButonu testid="indir-sayfa" />}
        {durum === "yok" && <div className="text-sm text-amber-300" data-testid="indir-hazir-degil">Kurulum dosyası henüz hazır değil.</div>}
        {durum === "yetkisiz" && <div className="text-sm text-amber-300" data-testid="indir-yetkisiz">Bu deneme sürümü şu an yalnızca yöneticilere açık.</div>}
        {durum === "giris" && <div className="text-sm text-amber-300" data-testid="indir-giris-gerekli">İndirmek için önce giriş yapın.</div>}
        <a href="/" className="block text-xs text-sertex-cyan/80 hover:underline" data-testid="indir-ana-sayfa">Ana sayfaya dön</a>
      </div>
    </div>
  );
}
